// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__gK0N3","dadosUsuario":"OptionSelect_dadosUsuario__MrHI2","focado":"OptionSelect_focado__2hQVT"};